module.exports = __webpack_public_path__ + "img/FrameFoundations_s0_b0_0_1_C0C_UK.8a22f265.png";